export const API_BASE_URL = "https://api.hjl.iosx.in/api/v1/";

